import React, { useEffect } from 'react';
import { JobManagementPage } from 'react-lib/dist/components-es';
import i18n from 'i18next';

import { useTranslation } from 'react-i18next';
import { useTitleDispatch } from '../TitleContextProvider';
import Connector from '../../agent';
import { keycloakConfig } from '../../keycloak';

const JobManagementPageWrapper = () => {
  const { t } = useTranslation();
  const dispatch = useTitleDispatch();
  const { apiConfig } = Connector;

  useEffect(() => {
    dispatch({
      pageTitle: t('job.management.page.title'),
    });
  }, [i18n.language]);

  return <JobManagementPage axiosConfig={apiConfig} keycloakConfig={keycloakConfig} />;
};

export default JobManagementPageWrapper;
